import { useEffect } from "react";
import { useLocation } from "wouter";

import { initGa4, trackPageView } from "@/lib/ga4";

function Analytics() {
  const [location] = useLocation();

  useEffect(() => {
    initGa4();
  }, []);

  useEffect(() => {
    trackPageView(location, document.title);
  }, [location]);

  return null;
}

export default Analytics;

